/**
 * Trunnion AI - Input Component
 * Text input with label and error state.
 */

import { forwardRef, type InputHTMLAttributes } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, helperText, className = '', id, ...props }, ref) => {
    const inputId = id ?? label?.toLowerCase().replace(/\s+/g, '-');

    return (
      <div className="flex flex-col gap-1.5">
        {label && (
          <label
            htmlFor={inputId}
            className="text-sm font-medium text-trunnion-slate-200"
          >
            {label}
          </label>
        )}
        <input
          ref={ref}
          id={inputId}
          className={`rounded-lg border bg-trunnion-slate-800 px-3 py-2 text-sm text-white placeholder-trunnion-slate-400 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-offset-trunnion-slate-950 ${
            error
              ? 'border-red-500 focus:ring-red-500'
              : 'border-trunnion-slate-600 focus:ring-trunnion-gold-500 hover:border-trunnion-slate-500'
          } ${className}`}
          {...props}
        />
        {error && <p className="text-xs text-red-400">{error}</p>}
        {helperText && !error && (
          <p className="text-xs text-trunnion-slate-400">{helperText}</p>
        )}
      </div>
    );
  },
);

Input.displayName = 'Input';
